// The onSubmit handler can return either void or Promise<void | T>, which triggers
// the no-misused-promises rule when passed to form.handleSubmit. This is a false positive
// since react-hook-form properly handles both synchronous and asynchronous submit handlers.
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { FormProps } from '../../../types/fileExplorerTypes';
import { UploadFileSchema } from './schemas';
import { InputField } from '../../Forms/Fields';
import { DropzoneField } from '../../Forms/Fields/DropzoneField';
import { formsConfig } from './config';

export function UploadFileForm({ form, children, onSubmit }: FormProps<UploadFileSchema>) {
  const { watch } = form;
  const files = watch('files');
  const isMultipleFiles = files?.length > 1;
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="modal-form">
        <DropzoneField<UploadFileSchema>
          name="files"
          label="Archivo"
          accept={formsConfig.commonAcceptedFiles}
          multiple
          showPreview
        />
        {!isMultipleFiles && files.length > 0 && (
          <>
            <InputField<UploadFileSchema>
              id="title"
              path="title"
              label="Nombre"
              placeholder="Nombre del archivo"
              required
            />
            <InputField<UploadFileSchema>
              id="description"
              path="description"
              label="Descripción"
              placeholder="Descripción del archivo"
            />
          </>
        )}
        {children}
      </form>
    </FormProvider>
  );
}
